import { computed, get } from '@ember/object';
import shuffleArray from '@intercom/pulse/lib/shuffle';

export default function shuffle(arrayKey) {
  return computed(function () {
    return shuffleArray(get(this, arrayKey));
  });
}
